import { css } from 'lit';

export const utilSheet = new CSSStyleSheet();

utilSheet.replaceSync(css`
  .bc-icon {
    font-family: 'BC Icons';
    font-feature-settings: 'liga';
    font-style: normal;
    text-rendering: optimizeLegibility;
    font-size: 1.5rem;
    line-height: 1;
    width: 1.5rem;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
  }
  .bc-icon-button {
    border-radius: 100%;
    padding: 3px;
    border: 1px solid var(--bc-brand-secondary-hover-00);
  }
  i.bc-icon {
    text-align: left;
  }
  .bc-flex {
    display: flex;
  }
  .bc-justify-content-center {
    justify-content: center;
  }
  .bc-align-items-center {
    align-items: center;
  }
  .bc-align-items-end {
    align-items: end;
  }
  .bc-direction-column {
    flex-direction: column;
  }
  .bc-justify-content-space-between {
    justify-content: space-between;
  }
  .bc-d-none {
    display: none;
  }
  .bc-p-3 {
    padding: 1rem;
  }
  .bc-p-4 {
    padding: 1.5rem;
  }
  .bc-mt-2 {
    margin-top: 0.5rem;
  }
  .bc-mt-3 {
    margin-top: 1rem;
  }
  .bc-mb-2 {
    margin-bottom: 0.5rem;
  }
  .bc-mb-3 {
    margin-bottom: 1rem;
  }
  .bc-gap-1 {
    gap: 0.25rem;
  }
  .bc-gap-2 {
    gap: 0.5rem;
  }
  main {
    width: 100%;
    height: 100%;
    display: unset;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  button {
    all: unset;
  }
`.cssText);
